const Button = ({ children, className = null, primary, ...props }) => (
  <button {...props} className={primary ? `btn btn-primary ${className}` : className}>
    {children}
  </button>
)

export default Button
